import { render } from "./collection-preview.vue?vue&type=template&id=51cf631e"
import script from "./collection-preview.vue?vue&type=script&lang=js"
export * from "./collection-preview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__